import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import { rememberLoginReturn } from '../utils/login-return.util';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private userService: UserService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private snackBar: MatSnackBar
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const isValid = this.userService.validateToken();
        if (isValid) {
            return true;
        } else {
            // The login comes back here (a patient file opened from RelayMD, a bookmark).
            rememberLoginReturn(state.url);
            this.snackBar.open('Your current session has expired. Please login to continue', 'OK', { duration: 3000, panelClass: ['themed-snackbar'] });
            // Signs out and loads /login as one fresh document. It does NOT route there first and
            // reload afterwards — that left an interactive login form on a page already condemned
            // by a pending reload, which on a slow connection is a window long enough to sign in
            // through. See `UserService.logoutAndRedirect`.
            this.userService.logoutAndRedirect();
            return false;
        }
    }
}